import type { ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { AiAgentSelect } from "@/react/components/shared/uikit/AiAgentSelect";
import { TextAreaWithCounter } from "@/react/pages/BotBuilder/BehaviorPage/TextAreaWithCounter";
import { Form } from "@circle-react-uikit/Form";
import { useCurrentAction } from "../../../ActionRule";
import { useDefaultValueForField } from "../../../useDefaultValueforField";
import "./styles.scss";

export const FormAiAgentsSendDM = () => {
  const { paramsPath } = useCurrentAction();

  const { getValues, setValue } = useFormContext();

  const selectedId = getValues(`${paramsPath}.community_bot_profile_id`) as
    | number
    | null;

  const aiPrompt = getValues(`${paramsPath}.ai_prompt`) as string | null;

  useDefaultValueForField(`${paramsPath}.community_bot_profile_id`, null);
  useDefaultValueForField(`${paramsPath}.ai_prompt`, "");

  return (
    <div className="workflows-form-ai-agents-send-dm flex flex-col gap-5">
      <Form.Item
        name={`${paramsPath}.community_bot_profile_id`}
        hideBorder
        fullWidth
        hideDescription
        label={t("settings.workflows.form.agent")}
        labelClassName="!mb-2 !text-sm"
        className="!py-0"
      >
        <AiAgentSelect
          selectedId={selectedId}
          setValue={(value: number) =>
            setValue(`${paramsPath}.community_bot_profile_id`, value)
          }
          placeholderKey="settings.workflows.form.select_agent"
          notFoundKey="settings.workflows.form.no_agents_found"
          enabledStatus
        />
      </Form.Item>
      <Form.Item
        name={`${paramsPath}.ai_prompt`}
        hideBorder
        fullWidth
        hideDescription
        label={
          <div>
            <Icon type="20-ai-prompt" size={20} className="mb-0.5 mr-1" />
            <span>{t("settings.workflows.form.additional_instructions")}</span>
          </div>
        }
        labelClassName="!mb-2 !text-sm"
        className="!py-0"
        placeholder={t("settings.workflows.form.ai_prompt_placeholder")}
        rules={{
          required: false,
        }}
      >
        <TextAreaWithCounter
          value={aiPrompt}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
            setValue(`${paramsPath}.ai_prompt`, e.target.value)
          }
          name={`${paramsPath}.ai_prompt`}
          rows={8}
          maxLength={500}
        />
      </Form.Item>
    </div>
  );
};
